/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Service_Add_GngInputs */

const vi_carrier_service_add_gng = /** @type {(inputs: Carrier_Service_Add_GngInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi hàng tại bưu cục`)
};

/**

* @param {Carrier_Service_Add_GngInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_service_add_gng = /** @type {((inputs?: Carrier_Service_Add_GngInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Service_Add_GngInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_service_add_gng(inputs)
});